// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__24zJB","log":"ModalInventoryLogs_log__2SGeQ","date":"ModalInventoryLogs_date__7ymWT","userName":"ModalInventoryLogs_userName__1cr3w"};